import { ChangeEventHandler, forwardRef, MouseEventHandler, Ref } from "react";

type Props = {
  inputRef?: Ref<HTMLInputElement>;
  onClick?: MouseEventHandler<HTMLInputElement>;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  value?: string | ReadonlyArray<string> | number;
  ["data-test-id"]?: string;
};

export const CustomDatePickerInput = forwardRef<HTMLInputElement>((props: Props, ref) => {
  return <input ref={ref} {...props} />;
});

CustomDatePickerInput.displayName = "CustomDatePickerInput";
